var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-page-header"
  }, [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Associations")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v(_vm._s(_vm.association.Name))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "field crud-buttons is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control hide-mobile"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [(_vm.isNewAssociation) ? _c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.postAssociation(_vm.association)
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (!_vm.isNewAssociation) ? _c('button', {
    staticClass: "button is-link",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        _vm.putAssociation(_vm.association)
      }
    }
  }, [_vm._v("Save")]) : _vm._e()]), _vm._v(" "), (!_vm.isNewAssociation) ? _c('div', {
    staticClass: "control"
  }, [_c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_vm._v("\n            Preview\n            "), _c('i', {
    staticClass: "fa fa-lg fa-file-pdf-o",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-file-pdf-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.isNewAssociation) ? _c('div', {
    staticClass: "control"
  }, [_c('el-popover', {
    ref: "popover5",
    attrs: {
      "placement": "bottom",
      "width": "500",
      "title": "Certificate Request Link"
    },
    model: {
      value: (_vm.showLinkPopover),
      callback: function($$v) {
        _vm.showLinkPopover = $$v
      },
      expression: "showLinkPopover"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.link))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover5",
      arg: "popover5"
    }],
    staticClass: "button is-link"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-link"
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isNewAssociation) ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link hide-mobile",
    on: {
      "click": function($event) {
        _vm.postRequest(_vm.association)
      }
    }
  }, [_vm._v("\n            Copy to Request\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    on: {
      "click": function($event) {
        _vm.postRequest(_vm.association)
      }
    }
  }, [_vm._v("\n            Copy\n          ")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-body"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.association.Name),
      expression: "association.Name"
    }],
    staticClass: "input is-small",
    class: {
      'is-required': _vm.missingName
    },
    attrs: {
      "type": "text",
      "placeholder": "Homeowners Association Name"
    },
    domProps: {
      "value": (_vm.association.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.association, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.missingName) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Please set Association Name\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Access Pin Number\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.association.PinNumber),
      expression: "association.PinNumber"
    }],
    staticClass: "input is-small",
    class: {
      'is-required': _vm.invalidPinNumber
    },
    attrs: {
      "type": "text",
      "placeholder": "Pin Number"
    },
    domProps: {
      "value": (_vm.association.PinNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.association, "PinNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.missingPinNumber) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Please set Pin Number\n            ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatePinNumber) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Pin Number already used, please use a different number\n            ")]) : _vm._e(), _vm._v(" "), (_vm.shortPinNumber) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Pin Number must be at least 5 characters\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Status\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.association.Status),
      expression: "association.Status"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.association, "Status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("Draft - Not Published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active - Published")])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-variable is-5 is-desktop",
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Accord24', {
    attrs: {
      "accord24": _vm.association.Accord24
    }
  }), _vm._v(" "), _c('Accord24', {
    ref: "accord",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accord24": _vm.association.Accord24,
      "readonly": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "multiple": "",
      "id": "uploadInput",
      "type": "file"
    },
    on: {
      "change": _vm.handleFileSelected
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    class: {
      'is-loading': _vm.isAttaching
    },
    on: {
      "click": _vm.attach
    }
  }, [_vm._v("Additional\n            Declarations\n            "), _c('i', {
    staticClass: "fa fa-paperclip",
    staticStyle: {
      "margin-left": "10px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "5px"
    }
  }, _vm._l((_vm.association.Attachments), function(attachment) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": attachment.downloadURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.fileName))])]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "margin-left": "8px",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.deleteAttachment(attachment)
        }
      }
    })])])
  }))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showCopyToRequestModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Copy to Request")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showCopyToRequestModal = false
      }
    }
  })]), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Owner Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.PropertyOwnerName),
      expression: "request.PropertyOwnerName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Owner Full Name"
    },
    domProps: {
      "value": (_vm.request.PropertyOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "PropertyOwnerName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.PropertyAddress),
      expression: "request.PropertyAddress"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Address"
    },
    domProps: {
      "value": (_vm.request.PropertyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "PropertyAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Loan Number")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.LoanNumber),
      expression: "request.LoanNumber"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Loan Number"
    },
    domProps: {
      "value": (_vm.request.LoanNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "LoanNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Certificate Holder")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.CertificateHolder),
      expression: "request.CertificateHolder"
    }],
    staticClass: "textarea",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Lender Certificiate Holder Information"
    },
    domProps: {
      "value": (_vm.request.CertificateHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "CertificateHolder", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.postRequest(this.association)
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showCopyToRequestModal = false
      }
    }
  }, [_vm._v("Cancel")])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section hide-mobile"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Association Information")]), _vm._v(" "), _c('hr')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-978aa3ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/associations/Association.vue
// module id = 0mr6
// module chunks = 1